// extracted by mini-css-extract-plugin
export default {"container":"otkyaTqXEAqy_vkl_joD"};